const STORAGE_KEY = 'ai_kb_search_history'
const MAX_ITEMS = 20

type HistoryStore = Record<string, string[]>

function readStore(): HistoryStore {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const data = JSON.parse(raw) as unknown
    if (!data || typeof data !== 'object') return {}
    return data as HistoryStore
  } catch {
    return {}
  }
}

function writeStore(store: HistoryStore) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store))
}

/** 按库别读取最近搜索词（新 → 旧） */
export function loadSearchHistory(scope: string): string[] {
  const sc = (scope || 'enterprise').trim() || 'enterprise'
  const list = readStore()[sc]
  return Array.isArray(list) ? list.filter((x) => typeof x === 'string' && x.trim()) : []
}

/** 搜索成功后写入历史（去重、置顶） */
export function pushSearchHistory(scope: string, query: string) {
  const text = query.trim()
  if (text.length < 1) return
  const sc = (scope || 'enterprise').trim() || 'enterprise'
  const store = readStore()
  const prev = loadSearchHistory(sc).filter((x) => x !== text)
  store[sc] = [text, ...prev].slice(0, MAX_ITEMS)
  writeStore(store)
}

/** 清空当前库别搜索历史 */
export function clearSearchHistory(scope: string) {
  const sc = (scope || 'enterprise').trim() || 'enterprise'
  const store = readStore()
  delete store[sc]
  writeStore(store)
}
